const PIXELSOFFSET = 65;

export const moveEventsScrollbar = positionsNumber => {
    const scrollElement = document
        .getElementsByClassName('events-list')[0];
    const offset = positionsNumber * PIXELSOFFSET;
    scrollElement.scrollTop = offset;
};